import { render, staticRenderFns } from "./media-menu.vue?vue&type=template&id=23367c7e&scoped=true"
import script from "./media-menu.vue?vue&type=script&lang=js"
export * from "./media-menu.vue?vue&type=script&lang=js"
import style0 from "./media-menu.vue?vue&type=style&index=0&id=23367c7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23367c7e",
  null
  
)

export default component.exports